document.addEventListener('DOMContentLoaded', () => {
  handleSLApp();
});

function handleSLApp() {
  const parentElement = document.querySelector('#sc-store-locator-map');

  const intervalId = setInterval(() => {
    if (typeof SL !== 'undefined') {
      if (SL.map) {
        clearInterval(intervalId);

        SL.map.addListener("tilesloaded", () => {
          const locations = document.querySelectorAll('.sl-address-item');

          // Check if locations contain loading placeholders
          const hasLoadingElements = Array.from(locations).some(loc =>
            loc.classList.contains('sl-loading-1')
          );

          if (hasLoadingElements) {
            // Poll for actual elements for up to 5 seconds
            let elapsed = 0;
            const maxWait = 5000;
            const pollInterval = 100;

            const checkInterval = setInterval(() => {
              elapsed += pollInterval;

              const updatedLocations = document.querySelectorAll('.sl-address-item');
              const stillLoading = Array.from(updatedLocations).some(loc =>
                loc.classList.contains('sl-loading-1')
              );

              if (!stillLoading || elapsed >= maxWait) {
                clearInterval(checkInterval);

                // Process the actual elements
                for (const location of updatedLocations) {
                  //TODO: Wrap the [hours] with a .hours div.
                  const hours = location.querySelector('.hours');
                  const status = location.querySelector('[data-sc-store-status]');

                  isStoreOpen(status, hours);
                  formatHours(hours);
                }
              }
            }, pollInterval);
          } else {
            // No loading elements, process immediately
            for (const location of locations) {
              const hours = location.querySelector('.hours');
              const status = location.querySelector('[data-sc-store-status]');

              isStoreOpen(status, hours);
              formatHours(hours);
            }
          }
        });
      }
    }
  }, 100);

  parentElement.addEventListener('click', function(event) {
    const accordionBtn = event.target.closest('[data-sc-accordion-toggle]');
    const actionBtn = event.target.closest('.sl-address-action-bttn');

    if (accordionBtn) {
      const accordionContainer = accordionBtn.closest('.sc-accordion');
      const isAlreadyActive = accordionBtn.classList.contains('active'); 
      const activeAccordions = document.querySelectorAll('.sc-accordion:has(>.sc-accordion__body.active)');
    
      if (accordionContainer) {
        const accordionBody = accordionContainer.querySelector('.sc-accordion__body');

        for (const activeAccordion of activeAccordions) {
          activeAccordion.querySelector('.sc-accordion__body').classList.remove('active');
          activeAccordion.querySelector('[data-sc-accordion-toggle]').classList.remove('active');
        }
        
        if (accordionBody && !isAlreadyActive) {
          accordionBody.classList.toggle('active');
          accordionBtn.classList.toggle('active');
        }
      }
    } else if (actionBtn) {
      document.querySelectorAll('.sl-address-action-bttn').forEach(btn => {
        if (btn !== actionBtn) {
          btn.classList.remove('active');
        }
      });

      actionBtn.classList.add('active');
    }
  });
}

function isStoreOpen(el, hours) {
  if (!el || !hours) return;

  const now = new Date();
  const hoursArray = parseHoursFromGrid(hours);
  const storeStatus = checkStoreStatus(hoursArray, now);

  if (storeStatus.isOpen) {
    el.textContent = `Open Today until ${storeStatus.closingTime}`;
  }
}

function parseHoursFromGrid(gridElement) {
  if (!gridElement) return [];

  const innerHTML = gridElement.innerHTML;
  const hoursArray = innerHTML
    .split(/<br\s*\/?>/i)
    .map(line => {
      const temp = document.createElement('div');
      temp.innerHTML = line;
      return temp.textContent || temp.innerText || '';
    })
    .map(line => line.trim())
    .filter(line => line.length > 0)
    .map(line => {
      return line.replace(/^["']|["']$/g, '');
    });

  return hoursArray;
}

function extractTimezoneInfo(timeString) {
  const timezoneMap = {
    'AEST': 'Australia/Sydney',
    'AEDT': 'Australia/Sydney',
    'AWST': 'Australia/Perth',
    'ACST': 'Australia/Adelaide',
    'ACDT': 'Australia/Adelaide',
  };

  const tzMatch = timeString.match(/\b([A-Z]{3,4})\b/);
  if (tzMatch) {
    const tzAbbr = tzMatch[1];
    return {
      abbreviation: tzAbbr,
      ianaTimezone: timezoneMap[tzAbbr] || 'Australia/Sydney' // Default to Sydney if not found
    };
  }

  return {
    abbreviation: 'AEST',
    ianaTimezone: 'Australia/Sydney'
  };
}

function checkStoreStatus(hoursArray, currentTime) {
  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const currentDay = dayNames[currentTime.getDay()];
  const todayHours = hoursArray.find(line => 
    line.toLowerCase().startsWith(currentDay.toLowerCase())
  );

  if (!todayHours) {
    return { isOpen: false };
  }

  const timezoneInfo = extractTimezoneInfo(todayHours);
  const timePattern = /(\d{1,2}:\d{2})(?:\s*([A-Z]{3,4}))?/g;
  const timeMatches = [...todayHours.matchAll(timePattern)];

  if (!timeMatches || timeMatches.length < 2) {
    return { isOpen: false };
  }

  const openTime = timeMatches[0][1];
  const closeTime = timeMatches[1][1];

  const { isOpen, closingTimeUser } = compareWithStoreTimezone(
    openTime,
    closeTime,
    currentTime,
    timezoneInfo.ianaTimezone
  );
  
  return {
    isOpen,
    closingTime: closingTimeUser
  };
}

function compareWithStoreTimezone(openTime, closeTime, userCurrentTime, storeTimezone) {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const today = new Date();
  const [openHour, openMin] = openTime.split(':').map(Number);
  const [closeHour, closeMin] = closeTime.split(':').map(Number);
  const storeNowString = today.toLocaleString("en-US", {timeZone: storeTimezone});

  const storeOpen = new Date(storeNowString);
  storeOpen.setHours(openHour, openMin, 0, 0);

  const storeClose = new Date(storeNowString);
  storeClose.setHours(closeHour, closeMin, 0, 0);

  if (storeClose <= storeOpen) {
    storeClose.setDate(storeClose.getDate() + 1);
  }

  const userOpen = new Date(storeOpen.toLocaleString("en-US", {timeZone: userTimezone}));
  const userClose = new Date(storeClose.toLocaleString("en-US", {timeZone: userTimezone}));
  const utcUserOpen = userOpen.getTime();
  const utcUserClose = userClose.getTime();
  const utcUserCurrent = userCurrentTime.getTime();

  const isOpen = utcUserCurrent >= utcUserOpen && utcUserCurrent < utcUserClose;

  const closingTimeUser = userClose.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).replace(/\s+/g, '');

  return { isOpen, closingTimeUser };
}

function convertTo12Hour(timeString) {
  const [hourStr, minuteStr] = timeString.split(':');
  let hour = parseInt(hourStr, 10);
  const minute = minuteStr || '00';
  const ampm = hour >= 12 ? 'PM' : 'AM';

  hour = hour % 12;
  hour = hour ? hour : 12;

  return `${hour}:${minute} ${ampm}`;
}

function formatHours(hours) {
  if(!hours) return;

  const hoursArray = parseHoursFromGrid(hours);
  let newContent = '';
  let allHoursMatch = true;
  const structureRegex = /^(\w+),\s*(\d{1,2}:\d{2})\s*[A-Z]{3,4},\s*(\d{1,2}:\d{2})\s*[A-Z]{3,4}$/;

  for (const hourString of hoursArray) {

    const match = hourString.match(structureRegex);

    if (match) {
      const parts = hourString.split(',').map(p => p.trim()).filter(p => p.length > 0);

      if (parts.length >= 3) {
        const day = parts[0];
        const openTime24 = parts[1].split(' ')[0]; 
        const closeTime24 = parts[2].split(' ')[0];
        const openTime12 = convertTo12Hour(openTime24);
        const closeTime12 = convertTo12Hour(closeTime24);

        const timeRange = `${openTime12} - ${closeTime12}`;
        newContent += `<p>${day}</p><p> ${timeRange}</p>`;
      }
    } else {
      allHoursMatch = false;
      break;
    }
  }

  if (allHoursMatch) {
    hours.innerHTML = newContent;
  }
}
